import { subscriptionRepository } from '../repositories/subscription-repository';

async function cancelSubscription(subscriptionId) {
    if (!subscriptionId) {
        throw Error('Cannot cancel subscription');
    }

    return subscriptionRepository.cancel(subscriptionId);
}

export {
    cancelSubscription
};
